import { FC, PropsWithChildren } from 'react';
import { CatModal } from '@blocks-react/components/Modal';
import { CatModalProps } from '../types';

export const RequestServiceModal: FC<PropsWithChildren<CatModalProps>> = ({
  children,
  ...modelProps
}) => {
  return <CatModal {...modelProps}>{children}</CatModal>;
};
